const $ = require('jquery');
const Cookies = require('js-cookie');

/**
 * Client module and wrapper around js-cookie that handles privacy settings.
 *
 * @module js/cookie
 * @see https://github.com/js-cookie/js-cookie
 */
module.exports = {
    /**
     * Checks is the cookie is allowed by ajax call
     *
     * @param {string} key - cookie name
     * @param {Function} callback - only called if coocie is allowed
     */
    whenAllowed(key, callback) {
        if (typeof callback !== 'function') {
            return;
        }
        this.isAllowed(key, result => {
            if (result) {
                callback();
            }
        });
    },

    /**
     * Checks is the cookie is allowed by ajax call
     *
     * @param {string} key - cookie name
     * @param {function(boolean):void} callback - receives true is allowed
     */
    isAllowed(key, callback) {
        if (typeof callback !== 'function') {
            return;
        }
        $.ajax({
            type: 'POST',
            url: Urls.isCookieAllowed,
            data: {name: key},
            /**
             * @param {string} response - json string
             * @returns {void}
             */
            success: response => callback(JSON.parse(response).allowed)
        });
    },

    /**
     * Setting a coookie with Ajax
     *
     * @param {string} key - cookie name
     * @param {string} value - cookie value
     * @param {Object?} attributes - attributes
     * @param {string} attributes.expires - expiration date
     * @returns {JQuery.jqXHR<any>} - jQuery ajax object
     */
    set(key, value, attributes) {
        return $.ajax({
            type: 'POST',
            url: Urls.setCookie,
            data: {
                name: key,
                value,
                expires: attributes ? attributes.expires : null
            }
        });
    },

    // delegate to js-cookie (no special handling needed)
    get: Cookies.get,
    remove: Cookies.remove,

    /**
     * get JSON parsed coockie content or null
     *
     * @param {string} name - cookie name
     * @returns {any} - result
     */
    getJSON(name) {
        try {
            return JSON.parse(Cookies.get(name));
        } catch (e) {
            return null;
        }
    }
};
